import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import {
  BatchSelectionRequest,
  BatchSelectionResponse,
} from "@src/core/engine/workers/batchSelection/schema";
import { createContext } from "react";

export type FetchSuggestions = (
  request: Omit<
    BatchSelectionRequest,
    | "accessToken"
    | "customPipeSeries"
    | "filters"
    | "pipeSeriesPreference"
    | "technicalSettings"
    | "type"
    | "waterCharacteristics"
  >,
) => Promise<BatchSelectionResponse>;

type BatchSuggestionsContextType = {
  fetchSuggestions: FetchSuggestions;
};

export const BatchSuggestionsContext =
  createContext<BatchSuggestionsContextType>(createDefaultContext());
